module.exports = __webpack_public_path__ + "static/media/rating_5.0e3acf1d.png";